import { render, staticRenderFns } from "./GlyphCanvas.vue?vue&type=template&id=25f86229&scoped=true&lang=html&"
import script from "./GlyphCanvas.vue?vue&type=script&lang=js&"
export * from "./GlyphCanvas.vue?vue&type=script&lang=js&"
import style0 from "./GlyphCanvas.vue?vue&type=style&index=0&id=25f86229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f86229",
  null
  
)

export default component.exports